import React from "react";
import PropTypes from "prop-types";
import "./loader.scss";

const Loader = (props) => (
  <>
    {props.showLoader ? (
      <div className='overlay'>
        <div className='overlay__inner'>
          <div className='overlay__content'>
            <span className='spinner' />
          </div>
        </div>
      </div>
    ) : (
      ""
    )}
  </>
);

Loader.propTypes = {
  showLoader: PropTypes.bool.isRequired,
};

export default Loader;
